export const SELF_OUT_OF_SCOPE_MESSAGE =
  "You can't mark yourself out of scope.";

export const getEmployeeDataId = (employee) =>
  employee?.employee_data_id ??
  employee?._originalEmployee?.employee_data_id ??
  null;

export const isSelfEmployee = (employee, currentEmployeeDataId) => {
  const employeeDataId = getEmployeeDataId(employee);
  if (!employeeDataId || !currentEmployeeDataId) return false;
  return String(employeeDataId) === String(currentEmployeeDataId);
};
